import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot,  CanActivate,  Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggedUserService } from '../services/logged-user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  implements CanActivate{
  constructor(private router: Router, private jwtHelper: JwtHelperService, private authService: AuthenticationService, private loggedUserService: LoggedUserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const token = localStorage.getItem('access_token');

    if (token && !this.jwtHelper.isTokenExpired(token) && this.loggedUserService.loggedUser)
    {
      return true
    } else {
      this.authService.removeLogedUser();
      return this.router.createUrlTree(['/login']);
    }
  }
}
